import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@one-thd/sui-atomic-components';
import { parseLabel,
  getRefinementLabel,
  extractFirstValue } from '../../../product-results-helpers';

const NumericRangeMenu = ({ items, onClickOfDropDown, minValue, isMaxValue }) => {
  let refinements = items;

  // Apply filter only for upper bound
  if (isMaxValue) {
    const lowerBound = parseLabel(minValue) || 0;
    refinements = refinements.filter((refinement) => extractFirstValue(getRefinementLabel(refinement)) > lowerBound);
  }

  return (
    <>
      {refinements.map((item) => {
        const valueType = !isMaxValue ? 'minValue' : 'maxValue';
        const testId = `menuItem-${valueType}-${item.label.split(' ')[0]}`;

        return (
          <MenuItem
            key={`numeric-${item.label}`}
            id={testId}
            data-testid={testId}
            onMouseDown={onClickOfDropDown}
          >
            {item.label}
          </MenuItem>
        );
      })}
    </>
  );
};

NumericRangeMenu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired
  })).isRequired,
  onClickOfDropDown: PropTypes.func.isRequired,
  isMaxValue: PropTypes.bool.isRequired,
  minValue: PropTypes.string.isRequired
};

export default NumericRangeMenu;